@if (invite) {
  <section class="ignosis-transfer">
    <header>
      <div class="ignosis-transfer-title">
        <strong>Transferred call</strong>
        @if (invite.dueId) {
          <a class="ignosis-goto-case" [routerLink]="['/timeline', invite.dueId]">Go To Case</a>
        }
      </div>
      @if (invite.reason) {
        <p>{{ invite.reason }}</p>
      }
      @if (!invite.dueId) {
        <p class="ignosis-transfer-muted">No matching case for this transfer.</p>
      }
    </header>
    <iframe #frame [src]="frameUrl" title="Transferred call" allow="microphone; autoplay"></iframe>
    <button type="button" (click)="state === 'joined' ? leave() : decline()">
      {{ state === 'joined' ? 'Leave call' : 'Decline' }}
    </button>
  </section>
}
@if (notice) {
  <p class="ignosis-transfer-notice">{{ notice }}</p>
}
